<template>
  <div class="calculator__stats">
    <error v-if="error" @click="getData"/>
    <sf-loading v-else-if="loading && !disabled && infoVisible" overlay/>
    <div class="calculator__stats__rows sf-ph-s">
      <slot :data="displayed"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Error from '../error.vue';

export default {
  components: { Error },
  props: {
    infoVisible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('arithmetic', [
      'error',
      'loading',
      'disabled',
      'displayed',
      'discount',
      'offerKey',
    ]),
  },
  watch: {
    offerKey: {
      immediate: true,
      handler() {
        if (process.browser) this.$store.dispatch('arithmetic/getData');
      },
    },
  },
  methods: {
    ...mapActions('arithmetic', ['getData']),
  },
};
</script>

<style lang="scss" scoped>
.calculator {
  &__stats {
    position: relative;
    padding: 5px 0;

    &__rows {
      width: 100%;
    }

    &__rows > * {
      @extend %flex-row;
      height: 40px;
      justify-content: space-between;

      &:last-child {
        border: none;
      }

      & > * {
        padding-right: map-get($map: $paddings, $key: small);

        &:last-child {
          padding-right: 0;
          white-space: nowrap;
          text-align: right;
          font-weight: 700;
          flex-shrink: 0;
        }
      }
    }
  }
}
</style>
